import { LoaderFunction } from "react-router-dom";
import { axiosApi } from "../../interceptors/axios";
import { Result } from "../../types/Result";

export const cityLoader: LoaderFunction = async (args) => {
    if (args.params.cityCode === "new") {
        return new Promise((res) => res(Result.newResult()))
    }
    const result = await axiosApi.get("/api/Cities/" + args.params.cityCode);
    return result.data
}